import React, { useEffect, useState } from 'react'
import { Card, CardContent, makeStyles } from '@material-ui/core'
import { COLORS } from 'src/utils/Themes/colors'
import ColumnChart from 'src/components/common/charts/ColumnChart'

const CHART_HEIGHT = 223
const CHART_COLORS = [COLORS?.DARK_PINK, COLORS?.LIGHT_BLUE_01]

const ClaimConsumption = ({ claimConsumptionCounts }) => {
  const classes = useStyles()
  const [claims, setClaims] = useState([])
  const [claimAmount, setClaimAmount] = useState([])
  const [xAxisLabels, setXAxisLabels] = useState([])

  useEffect(() => {
    if (claimConsumptionCounts) {
      if (claimConsumptionCounts?.length !== 0) {
        let noOfClaims = []
        let totalClaimAmount = []
        let totalSeries = []
        claimConsumptionCounts?.forEach((item) => {
          noOfClaims?.push(item?.numberOfClaims)
          totalClaimAmount?.push(item?.totalClaimAmount)
          totalSeries?.push(item?.identity)
        })
        setClaims(noOfClaims)
        setClaimAmount(totalClaimAmount)
        setXAxisLabels(totalSeries)
      }
    }
  }, [claimConsumptionCounts])

  return (
    <>
      <div className={classes.root}>
        <Card className={classes.cardContainer}>
          <CardContent className={classes.cardContainerContent}>
            <h2 className={classes.title}>Claim Consumption Report</h2>
            <ColumnChart
              noOfClaims={claims}
              totalClaimAmount={claimAmount}
              xAxisLabels={xAxisLabels}
              height={CHART_HEIGHT}
              colors={CHART_COLORS}
            />
          </CardContent>
        </Card>
      </div>
    </>
  )
}

export default ClaimConsumption

const useStyles = makeStyles({
  root: {
    width: '100%',
    boxSizing: 'border-box',
    borderRadius: '10px',
    textAlign: 'center',
    // boxShadow: "4px 7px 15px rgba(0, 0, 0, 0.1)",
  },
  title: {
    fontSize: '18px',
    lineHeight: '22px',
    marginTop: '0px',
    color: COLORS.GREY,
    display: 'flex',
    width: '100%',
    alignItems: 'center',
    justifyItems: 'center',
    flexDirection: 'column',
    fontWeight: '600',
  },
  cardContainer: {
    borderRadius: '10px',
  },
  supportText: {
    marginTop: 0,
    fontSize: 17,
  },
  btnLabel: {
    textTransform: 'capitalize',
    color: COLORS.LINK_COLOR_DARK,
    textDecoration: 'underline',
    marginTop: '20px',
  },
  modalClass: {
    height: '90%',
    overflow: 'auto',
  },
  cardContainerContent: {
    padding: '20px 0px 6px 0px',
  },
})
